interface Node {
    parent: number;
    size: number;
}

export class DisjointSetForest {
    private backing = new Map<number, Node>();

    public add(x: number): DisjointSetForest {
        if (this.backing.get(x) === undefined) {
            this.backing.set(x, { parent: x, size: 1 });
        }
        return this;
    }

    public find(x: number): number | undefined {
        let curID = x,
            cur = this.backing.get(x);
        while (cur !== undefined && cur.parent !== curID) {
            curID = cur.parent;
            cur = this.backing.get(curID);
            if (cur !== undefined && cur.parent !== curID) {
                const grandparent = this.backing.get(cur.parent);
                if (grandparent !== undefined) {
                    cur.parent = grandparent.parent;
                }
            }
        }
        return cur === undefined ? undefined : curID;
    }

    public union(x: number, y: number): number | undefined {
        const topX = this.find(x);
        const topY = this.find(y);

        if (topX === undefined || topY === undefined || topX === topY) {
            return undefined;
        }

        const nodeX = this.backing.get(topX);
        const nodeY = this.backing.get(topY);

        if (nodeX === undefined || nodeY === undefined) {
            return undefined;
        }

        if (nodeX.size < nodeY.size) {
            nodeX.size += nodeY.size;
            nodeY.parent = topX;
            return topX;
        } else {
            nodeY.size += nodeX.size;
            nodeX.parent = topY;
            return topY;
        }
    }
}
